import { render, staticRenderFns } from "./img-two.vue?vue&type=template&id=359fc350&scoped=true&"
import script from "./img-two.vue?vue&type=script&lang=js&"
export * from "./img-two.vue?vue&type=script&lang=js&"
import style0 from "./img-two.vue?vue&type=style&index=0&id=359fc350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359fc350",
  null
  
)

export default component.exports